const features = [
  { icon: "ri-settings-3-line", text: "Universal fit — installs on most folding and rigid wheelchairs in minutes" },
  { icon: "ri-tools-line", text: "Quick-release design — tool-free removal of the PowerTube in seconds" },
  { icon: "ri-swap-line", text: "Fast charging & swappable battery — easy battery removal" },
  { icon: "ri-gamepad-line", text: "Joystick flexibility — quick disconnect, ambidextrous & attendant control" },
  { icon: "ri-flight-takeoff-line", text: "Travel ready — FAA-compliant battery for easier air travel" },
  { icon: "ri-shield-check-line", text: "Warranty — 1-year battery, 2-year motor limited warranty" },
];

export default function PowerMeetsStyle() {
  return (
    <section className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div id="powertube" className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-5xl font-black mb-4 tracking-tight">POWER MEETS STYLE</h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Our patented PowerTube delivers instant torque and whisper-quiet operation — just 9 lb without battery, 12.5 lb with. Never be limited by where the road takes you.
            </p>

            {/* Feature List */}
            <ul className="space-y-3">
              {features.map((f) => (
                <li key={f.icon} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center text-teal-400 flex-shrink-0 mt-0.5">
                    <i className={f.icon}></i>
                  </div>
                  <span className="text-sm text-gray-300 leading-snug">{f.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="order-1 lg:order-2 w-full h-[320px] sm:h-[440px] lg:h-[640px]">
            <img
              src="https://static.readdy.ai/image/c396747a877dd1d0cb2c362594545533/860a048226c08af78787805a86a4cb3a.jpeg"
              alt="PowerTube system installed on wheelchair"
              width="1280"
              height="640"
              className="w-full h-full object-cover object-center rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
